module.exports = __webpack_public_path__ + "img/done-check.de0bfc0.png";